var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AgendaSessionBox',{attrs:{"session":_vm.session,"view":"large","alt-title":_vm.altTitle,"starred":_vm.starred,"popup":true},on:{"clicked":_vm.onClick}}),_c('span',{staticClass:"close",on:{"click":_vm.cancel}},[_vm._v("×")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }